import { IShareBaseSocket, SocketSubject } from '../sockets';
import { SocketFactory } from '../socket-factory';
import { AuthService } from 'phoenix/services';

export type IOnlineUsersService = OnlineUsersService;
const featureName = 'Core/RTSActiveUsers';

/**
 * A service that exposes methods for joining a web socket room for a deployment.
 * It also exposes properties about the room.
 */
export class OnlineUsersService {
    public static $inject = [
        '$timeout',
        'sbrtsSocketFactory',
        'pxAuthService'
    ];

    private deploymentId: number;
    private socket: IShareBaseSocket;
    private roomUsers: SocketSubject[];

    /**
     * An array of users in the room, including the current user.
     */
    public get users():SocketSubject[] {
        return this.roomUsers;
    }

    /**
     * An array of users in the room that excludes the current user.
     */
    public otherUsers: SocketSubject[];

    constructor(
        private readonly $timeout,
        private readonly factory: SocketFactory,
        private readonly auth: AuthService
    ) { }

    /**
     * Join a document room with the given document id.
     */
    public joinRoom(deploymentId: number | string) {
        if (typeof deploymentId === 'string') {
            deploymentId = parseInt(deploymentId, 10);
        }

        if (deploymentId !== this.deploymentId) {
            this.deploymentId = deploymentId;

            let roomNo = `document-view-${this.deploymentId}`;
            // leave the current room
            this.leaveRoom();

            this.factory.create(featureName)
                .then(socket => {
                    this.socket = socket;
                    this.socket.joinRoom(roomNo, users => {
                        this.roomUsers = this.getUniqueUsers(users);
                        this.otherUsers = this.roomUsers.filter(u => u.userId !== this.auth.userId);
                    });
                });
        }
    }

    /**
     * Leave the current document room.
     */
    public leaveRoom() {
        if (this.socket) {
            this.socket.disconnect();
            this.deploymentId = -1;
        }
    }

    private getUniqueUsers(users: SocketSubject[]) {
        let uhash: { [index: number]: SocketSubject } = { };
        for (let u of users) {
            if (!(u.userId in uhash)) {
                uhash[u.userId] = u;
            }
        }

        return Object.keys(uhash).map((key) => uhash[key]);
    }
}


// WEBPACK FOOTER //
// ./src/real-time/view-services/online-users.service.ts